import { TestBackendImpl } from './TestBackend';
export * from './TestBackend';
var instance;
export function getInstance() {
  return instance;
}
export function clearInstance() {
  instance = undefined;
}
export var TestBackend = function createBackend(manager) {
  instance = new TestBackendImpl(manager);
  return instance;
};